/* axiosのラッパー */
import axios from 'axios';
const instance = axios.create({
  baseURL: process.env.MIX_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': process.env.MIX_ALLOW_ORIGIN || '',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const res = error.response;
    switch (res.status) {
      case 503:
        window.location.href = '/maintenance';
        break;
      default:
        break;
    }
    return Promise.reject(error);
  }
);

export default instance;
